import { MutableRefObject, useEffect, useState } from 'react';
import { GetDimensionsType } from './useDimensions';

const getDimensions = (el: HTMLImageElement): GetDimensionsType => {
  const { naturalWidth: width, naturalHeight: height } = el;
  const hasScrollbar = el.scrollHeight > height;

  return {
    width,
    height,
    hasScrollbar
  };
};

const initialDimensions: GetDimensionsType = {
  width: 0,
  height: 0,
  hasScrollbar: false
};

export const useNativeImageSize = (ref: MutableRefObject<HTMLImageElement | null>) => {
  const [dimensions, setDimensions] = useState<GetDimensionsType>(initialDimensions);

  const elem = ref.current;

  useEffect(() => {
    if (elem) {
      setDimensions(getDimensions(elem));
    } else {
      setDimensions(initialDimensions);
    }
  }, [elem]);

  return dimensions;
};
